import { c as _c } from "react/compiler-runtime";
import { FlexContainer, Title } from '@/shared/ui';
import { Tooltip } from '@ncai-axe/react-ui-v3';
import IcInformationFill from '@ncai-axe/react-ui-v3/assets/svg/icons/ic_information_fill.svg';
import styles from './styles.module.scss';
type Props = {
  label: string;
  tooltip?: string;
  imageCount: number;
  maxImageCount: number;
};
export default function ImageCount(t0) {
  const $ = _c(19);
  const {
    label,
    tooltip,
    imageCount,
    maxImageCount
  } = t0;
  let t1;
  if ($[0] !== label) {
    t1 = <Title label={label} />;
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== tooltip) {
    t2 = tooltip && <Tooltip className={styles.tooltip} content={tooltip}><div className={styles.tooltipIcon}><IcInformationFill className={styles.infoIcon} /></div></Tooltip>;
    $[2] = tooltip;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <FlexContainer alignItems="center" gap={4}>{t1}{t2}</FlexContainer>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = imageCount > 0;
  let t5;
  if ($[7] !== imageCount) {
    t5 = <span>{imageCount}</span>;
    $[7] = imageCount;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span>/</span>;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== maxImageCount) {
    t7 = <span>{maxImageCount}</span>;
    $[10] = maxImageCount;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t4 || $[13] !== t5 || $[14] !== t7) {
    t8 = <div className={styles.count} data-has-count={t4}>{t5}{t6}{t7}</div>;
    $[12] = t4;
    $[13] = t5;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t3 || $[17] !== t8) {
    t9 = <FlexContainer justifyContent="flex-start" gap={8} height="32px" width="fit-content">{t3}{t8}</FlexContainer>;
    $[16] = t3;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
}